/**
 * Файл для переделки, когда логика будет сделана на беке
 */
export default {
  /**
   * Объединяет базовые, и вычисленные выше, платные услуги
   * @returns array
   */
  managedServices(state, getters) {
    return getters.copyServices
  },

  /**
   * Скрываем из выдачи спрятанные платные услуги
   * @returns array
   */
  showedServices(state, getters) {
    return getters.managedServices.filter(service => service.isVisible)
  },

  /**
   * Возвращает массив выбранных услуг
   * @returns array
   */
  addedServices(state, getters) {
    // Услуги, выбранные в списке платных услуг
    return getters.managedServices.filter(service => service.isChecked)
  },

  anonimousServices(state, getters) {
    const whiteList = [
      'd_handing_sms',
      'd_uncomfortable_cargo',
      'd_experienced_cour',
      'd_delicate_cargo',
      'd_high_priority_display',
      'd_accentuate_in_list',
    ]

    return whiteList.map(alias => getters.namedServices[alias]).filter(alias => alias !== undefined)
  },

  /**
   * Возвращает массив ID выбранных услуг
   * @returns array
   */
  addedServicesID(state, getters) {
    return getters.addedServices.map(service => service.id)
  },

  /**
   * Именованный, по алиасам, список платных услуг
   * @example [namedServices.d_order_by_phone]
   * @returns object
   */
  namedServices: state => {
    const result = {}

    state.services.forEach(service => {
      result[service.alias] = service
    })

    return result
  },

  /**
   * Сервисы, дополнительно предлагаемые после создания заказа
   * @returns array
   */
  getUpsaleServices: state =>
    state.services.filter(
      service =>
        [
          'd_high_priority_display',
          'd_accentuate_in_list',
          'd_confirm_delivery_to_customer',
          'd_handing_sms',
        ].indexOf(service.alias) > -1
    ),

  /**
   * Копируем услугу, чтобы не изменять настоящую
   * @returns object
   */
  copyServices: state => structuredClone(state.services),

  copyServiceByName(state, getters) {
    return name => structuredClone(getters.namedServices[name] || {})
  },
}
